/**
 * Photos taken from the phone's floating "Vyfotit účtenku" button, handed to
 * the capture page it opens. In memory only: a reload starts over.
 */
let pending: File[] = [];

export function setPendingCapture(files: File[]): void {
  pending = files;
}

/** The handed-over files, once (the next call returns none). */
export function takePendingCapture(): File[] {
  const files = pending;
  pending = [];
  return files;
}
